import React from 'react';
import { renderCell } from '../../../Utils/gridDefaultValues';

function BasicCell({ params, value }) {
  return <>{renderCell({ params, value })}</>;
}

export default BasicCell;
